import React from 'react';

import CircleIcon from '@mui/icons-material/Circle';

import { Marker, Source, Layer } from 'react-map-gl';

import { userLocationRadius } from '../mapStyles';

const userPositionRadius = userLocationRadius();

export const UserLocationMarker = ({
  longitude,
  latitude,
  data
}) => {
    
  const styles = {
    icon: {
      fontSize: '1.5em',
      border: '3px solid #FFFFFF',
      borderRadius: '100vmax',
    }
  };

  return (
    <React.Fragment>
      <Marker  
        id='user_location' 
        key='location' 
        longitude={longitude} 
        latitude={latitude} 
      >
        <CircleIcon 
          id='user-location-icon' 
          color='primary'
          style= {styles.icon}
        />
      </Marker>
      <Source id='user-radius' type='geojson' data={data}>
        <Layer source='user-radius' {...userPositionRadius}  />
      </Source>
    </React.Fragment>
  );
};